module.exports = __webpack_public_path__ + "static/media/pswomen.a131a905.jpeg";